module.exports = "<div id=\"loading\" *ngIf=loading>\r\n    <ul class=\"bokeh\">\r\n        <li></li>\r\n        <li></li>\r\n        <li></li>\r\n    </ul>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loading/loading.component.html
// module id = ./src/app/loading/loading.component.html
// module chunks = main